import React from 'react';
import { Link } from 'react-router-dom';

const Page404 = () => {
  return (
    <section className="bg-white pt-20">
      <div className="py-8 px-4 mx-auto max-w-screen-xl lg:py-16 lg:px-6">
        <div className="mx-auto max-w-screen-sm text-center">
          <h1 className="mb-4 text-7xl tracking-tight font-extrabold lg:text-9xl text-primary-600">
            404
          </h1>
          <p className="mb-4 text-3xl tracking-tight font-bold text-gray-900 md:text-4xl ">
            Sayfa bulunamadı.
          </p>
          <p className="mb-4 text-lg font-light text-gray-500 ">
            Üzgünüz. Gitmek istediğiniz sayfa mevcut değil. Lütfen doğru adrese
            gittiğinizden emin olun.
          </p>
          <Link
            to="/"
            className="inline-flex text-white bg-yellow-600 hover:bg-yellow-700 transition-all focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center my-4"
          >
            Anasayfaya Dön
          </Link>
        </div>
      </div>
    </section>
  );
};

export default Page404;
